module.exports = __webpack_public_path__ + "static/media/city.cae0cf75.jpg";